import { SyntheticEvent, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { IsContent, IsPlatform } from "../../type/album";
import defaultImg from "../../asset/default.png";
import { useNavigate } from "react-router-dom";
import youtube from "../../asset/youtube.png";
import apple from "../../asset/apple.png";
import melon from "../../asset/melon.png";
import defaultCircle from "../../asset/defaultCircle.png";
import { media } from "../../media";
import { useAlbum } from "../../hooks/useAlbum";

export interface IsCard {
  index: number;
  openIndex: number | undefined;
  onClick: () => void;

  id: string;
  title: string;
  url: string;
  username: string;
  content: IsContent[];
  vocalList: string[];
  uid: string;
  currentUid: string;
  handlePrev: () => void;
  platform: IsPlatform;
}

export default function Card({
  index,
  openIndex,
  onClick,

  id,
  title,
  url,
  username,
  content,
  vocalList,
  uid,
  currentUid,
  handlePrev,
  platform,
}: IsCard) {
  const isDesktop = window.innerWidth > 767;
  const nav = useNavigate();
  const { searchByUid } = useAlbum();

  const addDefaultImg = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = defaultCircle;
  };

  const onWrite = (id: string) => {
    handlePrev();
    if (id) {
      nav(`/album/${id}`);
    } else if (!id) {
      nav(`/album/write`);
    }
  };

  const handleViewed = () => {
    if (isDesktop) return;
    onClick();
  };

  // useEffect(() => {
  //   setIsViewd(false);
  // }, []);

  return (
    <CardWrap onClick={handleViewed} isViewd={index === openIndex}>
      <div className="CardFront">
        <div className="ImgWrap">
          <img src={url || defaultCircle} alt="" onError={addDefaultImg} />
        </div>
        <div className="TextWrap">
          <div className="TextHeader">
            <h4>{title || "New Album"}</h4>
            <img
              src={
                platform === "youtube"
                  ? youtube
                  : platform === "apple"
                  ? apple
                  : platform === "melon"
                  ? melon
                  : defaultImg
              }
              alt=""
              onError={undefined}
            />
          </div>

          <p className="VocalOnly">{vocalList?.join(", ")}</p>
        </div>
        <div className="Bottom">
          {username && (
            <div
              className="UsernameWrap"
              onClick={() => searchByUid(uid, username)}
            >
              <p>{username}</p>
            </div>
          )}
        </div>
      </div>
      <div className="CardBack">
        <div className="ContentInner">
          <ul>
            {content
              .slice(0)
              .reverse()
              .map((con: any) => {
                return (
                  <li key={con.title}>
                    <a href={con.url} target="_blank" rel="noreferrer">
                      {con.title} - {con.vocal}
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
        <div className="ContentBottom">
          {uid === currentUid && (
            <div className="EditWrap" onClick={() => onWrite(id)}>
              <p>EDIT</p>
            </div>
          )}
        </div>
      </div>
    </CardWrap>
  );
}

const CardWrap = styled.div<{ isViewd: boolean }>`
  position: relative;
  width: 300px;
  height: 400px;
  background-color: white;
  z-index: 1;
  ${media.desktop`
    &:hover {
      .CardFront {
        margin-left: -200px;
        rotate: calc(-6deg);
      }
    }
  `}
  .CardFront {
    position: relative;
    width: 300px;
    height: 400px;
    border: 1px solid #314af3;
    background-color: white;
    overflow: hidden;
    padding: 10px;
    z-index: 10;

    transition: all 0.16s ease-out;
    margin-left: 0px;
    rotate: calc(0deg);
    ${({ isViewd }) =>
      isViewd &&
      css`
        margin-left: -200px;
        rotate: calc(-6deg);
      `}

    .ImgWrap {
      width: 280px;
      height: 280px;
      margin-bottom: 10px;
      img {
        /* border: 1px solid #314af3; */
        width: 280px;
        height: 280px;
        object-fit: cover;
        background-color: white;
      }
    }
    .TextWrap {
      margin-bottom: 14px;
      .TextHeader {
        display: flex;
        justify-content: space-between;
        h4 {
          font-family: gmarket-sans-medium;
          font-size: 16px;
          margin-bottom: 8px;
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
      p {
        font-family: gmarket-sans-medium;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .Bottom {
      position: absolute;
      bottom: 8px;
      right: 8px;
      display: flex;
      justify-content: end;
      align-items: end;
      .UsernameWrap {
        p {
          width: fit-content;
          font-family: nexa-bold;
          font-size: 12px;
          padding: 4px 8px;
          border: 1px solid #314af3;
          cursor: pointer;
          &:hover {
            background-color: #314af3;
            color: white;
          }
        }
      }
    }
  }
  .CardBack {
    position: absolute;
    top: 0;
    width: 300px;
    height: 400px;
    border: 1px solid #314af3;
    .ContentInner {
      width: 190px;
      max-height: 240px;
      overflow-y: auto;
      position: absolute;
      /* background-color: #f9f9f9; */
      top: 20px;
      right: 20px;
      padding: 4px;
      ul {
        display: flex;
        flex-direction: column;
        align-items: end;
        gap: 4px;
        li {
          a {
            font-family: gmarket-sans-medium;
            font-size: 13px;
            white-space: nowrap;
          }
        }
      }
    }
    .ContentBottom {
      position: absolute;
      bottom: 8px;
      right: 8px;
      display: flex;
      justify-content: end;
      align-items: end;
      .EditWrap {
        p {
          width: fit-content;
          font-family: nexa-bold;
          font-size: 12px;
          padding: 4px 8px;
          border: 1px solid #314af3;
          cursor: pointer;
          &:hover {
            background-color: #314af3;
            color: white;
          }
        }
      }
    }
  }
`;
